import {createStyles, Theme} from "@material-ui/core";
import {primaryColor, styleColors} from "src/main.style";

export const NextHandoverPerScheduleStyle = (theme: Theme) => createStyles({
  pane: {
    fontFamily: '"Metropolis", "Helvetica", "Arial", sans-serif',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    paddingTop: '23px',
    boxSizing: 'border-box',
    backgroundColor: styleColors.white,
    boxShadow: `0px -1px 23px ${styleColors.blackAlpha23}`,
  },
  // One schedule: the pane runs down to the bottom of the view, like an open note.
  paneSingle: {
    flex: '1 0 auto',
    borderRadius: '32px 32px 0px 0px',
    paddingBottom: 'calc(100px + env(safe-area-inset-bottom, 0px))',
  },
  // Several schedules: rounded cards stacked below each other.
  paneStacked: {
    flexShrink: 0,
    borderRadius: '32px',
    paddingBottom: '16px',
    marginBottom: '16px',
  },
  handoverHeader: {
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    fontSize: '0.938rem',
    /* Background image is the same purple in both themes, so the text
       on top must always be actual white — not styleColors.white which
       flips to the card surface (#323232) in dark mode. */
    color: '#FFFFFF',
    fontWeight: 'bold',
    borderRadius: '16px',
    margin: '0px 23px',
    paddingBottom: '10px',
    backgroundSize: 'cover',
    backgroundPosition: 'right center',
    backgroundImage: `url(${process.env.PUBLIC_URL}/handoverBackground2.png)`,
    position: 'relative',
    textAlign: 'left',
  },
  handoverHeaderAction: {
    padding: '4px 20px 10px',
  },
  seenByAll: {
    display: 'flex',
    alignItems: 'center',
    gap: '2px',
    padding: '10px 23px 0px',
    fontSize: '12px',
    color: styleColors.blackAlpha63,
    '& > span': {
      marginRight: '4px',
    },
  },
  unseenNotice: {
    color: primaryColor,
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '8px',
  },
  groupHeader: {
    padding: '16px 23px 4px',
    fontSize: '14px',
    fontWeight: 'bold',
    color: styleColors.blackAlpha63,
  },
  handoverHeaderTitle: {
    paddingBottom:'10px',
      fontWeight: 300,
      fontSize: '12px',
      color: '#FFFFFF',
      textAlign: 'left',
      width: '65%',
      wordBreak: 'break-word',
      paddingTop: '20px',
      paddingLeft: '20px',
  },
  handoverHeaderText: {
    paddingBottom:'10px',
      fontWeight:'bold',
      fontSize: '20px',
      color: '#FFFFFF',
      textAlign: 'left',
      width: '65%',
      wordBreak: 'break-word',
      paddingLeft: '20px',
  },
  warning : {
    margin: '0px 23px 16px',
    display: 'flex',
    padding: '20px',
    maxWidth: '500px',
    boxShadow: `0px 3px 30px ${styleColors.softPurpleShadow}`,
    boxSizing: 'border-box',
    minHeight: '124px',
    alignItems: 'center',
    fontWeight: 400,
    borderRadius: '10px',
    flexDirection: 'row',
    backgroundColor: styleColors.handoverYellow,
    color: '#333333',
    justifyContent: 'space-between',
  }
});



// WEBPACK FOOTER //
// ./src/components/next-handover/NextHandoverPerSchedule.style.ts